import getters from "./getters.js";
import actions from "./actions.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            authUrl:null,
            clientId: null, 
            accountId: null, 
            redirectUrl: null, 
            accountSecret: null, 
            connectedGooglePlayAccounts: [], 
            authBaseUrl: "https://accounts.google.com/o/oauth2/auth?scope=https://www.googleapis.com/auth/androidpublisher https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/firebase.messaging&redirect_uri=",
            packages:[]
        }
    },
    getters,
    actions,
    mutations
}